import React, { useState, useEffect } from "react";
import { FormControl, MenuItem, Select, InputLabel, Popper, Paper, ClickAwayListener } from '@mui/material';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { Button, InputAutocomplete } from 'src/mtska-frontend-app-component';
import JSONPretty from 'react-json-pretty';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import FiltersPanel from "src/mtska-frontend-app-component/components/List/FiltersPanel";
import { getColumnDefinition } from 'src/mtska-frontend-app-component/components/List/list.functions.jsx'
import { useDataProvider } from "src/mtska-frontend-data-provider";

const Filters = ({ dataProviderName, filters: defaultFilters, style }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const { settings, settingsLoaded, addFilter } = useSettingsContext(dataProviderName, defaultFilters);
    const [filterPanelVisible, setFilterPanelVisible] = useState(false);
    const { item: config } = useDataProvider('configs/config');

    const [advertisingSourceName, setAdvertisingSourceName] = useState();
    const [areaName, setAreaName] = useState();
    const [selectedValueYear, setSelectedValueYear] = useState();
    const [selectedValueLegalEntity, setSelectedValueLegalEntity] = useState();

    useEffect(() => {
        if (settingsLoaded == false) return;

        setAdvertisingSourceName(filterModel?.items?.find(f => f.field === '_related_source_name')?.value || null);
        setAreaName(filterModel?.items?.find(f => f.field === '_related_area_name')?.value || null);
        setSelectedValueYear(filterModel?.items?.find(f => f.field === 'year')?.value || null);
        setSelectedValueLegalEntity(filterModel?.items?.find(f => f.field === '_related_legalEntity_name')?.value || null);
    }, [filterModel])

    return (drawable &&
        <>
            {/* filterModel in Filters
            <JSONPretty data={filterModel} className="json-wrapper" style={{ overflow: 'scroll', fontSize: '10px' }}></JSONPretty> */}

            <Box className="section-filters" sx={style}>
 
                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="year-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueYear ? true : false}
                    >
                        {t("year")}
                    </InputLabel>
                    <Select
                        name="year"
                        value={selectedValueYear}
                        labelId="year-label"
                        onChange={(e) => {
                            setSelectedValueYear(e.target.value);
                            addFilter('year', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("select")}</MenuItem>
                        <MenuItem value="2026">{t("2026")}</MenuItem>
                        <MenuItem value="2025">{t("2025")}</MenuItem>
                        <MenuItem value="2024">{t("2024")}</MenuItem>
                    </Select>
                </FormControl>

                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="le-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueLegalEntity ? true : false}
                    >
                        {t("legalEntity_name")}
                    </InputLabel>
                    <Select
                        name="_related_legalEntity_name"
                        value={selectedValueLegalEntity}
                        labelId="le-label"
                        onChange={(e) => {
                            setSelectedValueLegalEntity(e.target.value);
                            addFilter('_related_legalEntity_name', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("select")}</MenuItem>
                        <MenuItem value="Elletre">{t("Elletre")}</MenuItem>
                        <MenuItem value="Levante">{t("Levante")}</MenuItem>
                        <MenuItem value="QuattroK">{t("QuattroK")}</MenuItem>
                    </Select>
                </FormControl>

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="commercials/area/autocomplete"
                    label={t('area')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={areaName ? { "name": areaName } : null}
                    onChange={(v) => {
                        addFilter('_related_area_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="advertisings/source/autocomplete"
                    label={t('source')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={advertisingSourceName ? { name: advertisingSourceName } : null}
                    onChange={(v) => {
                        addFilter('_related_source_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />
                
                {/* per ora disabilitiamo il bottone di apertura dei filtri
                <Button onClick={(e) => { e.stopPropagation(); setFilterPanelVisible(!filterPanelVisible)}} icon="faEllipsisVertical"></Button> 
                */}
            </Box>

            <ClickAwayListener onClickAway={() => setFilterPanelVisible(false)}>
                <Popper open={filterPanelVisible}>
                    <Paper>
                        <FiltersPanel dataProviderName={dataProviderName} columns={getColumnDefinition(settings, config, dataProviderName, t)} />
                    </Paper>
                </Popper>
            </ClickAwayListener>
        </>
    )
}

export default Filters;